export default "__VITE_ASSET__d1e1e39a__"